import React from 'react';
import { ACTIVE_TABS } from './constants';
import { SegmentedControl } from '../../Coupons/v2/_components/SegmentedControl';

export default function Abas({ activeTab = '', onTabChange }) {
  const options = [
    [ACTIVE_TABS.BILHETAGEM, 'Calculadoras e consultas'],
    [ACTIVE_TABS.OUTROS, 'Outros'],
  ];

  // SegmentedControl: o anel da opção ativa desliza entre as sub-abas.
  return (
    <div className="cd-pills">
      <SegmentedControl
        ariaLabel="Tipo de benefício"
        options={options.map(([value, label]) => ({ value, label }))}
        value={activeTab}
        onChange={onTabChange}
      />
    </div>
  );
}
